import SideFilterFrame from "../../components/common/SideFilterFrame";
import {
  ProposalCard,
  ProposalCardLoading,
} from "../../components/proposal/ProposalCard";
import Navbar from "../../components/common/NavBar";
import Header from "../../components/common/Header";
import { useAllProposalsData, useSingleChallengeData } from "../../lib/hooks";
import { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { ProposalFormType } from "../../lib/proposalAPI";
import {
  ChallengeQuickStats,
  ChallengeQuickStatsLoading,
} from "../../components/challenge/ChallengeQuickStats";
import SearchInput from "../../components/common/SearchInput";
import Footer from "../../components/common/Footer";
import LoadingError from "../../components/common/LoadingError";
import ProposalSortMenu from "../../components/proposal/ProposalSortMenu";
import styles from "../../styles/common/header.module.css";
import { FormatListBulletedSharp, GridView } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { proposalColumns } from "../../components/analytics/GridViewColumns";
import ProposalFilter from "../../components/proposal/ProposalFilter";

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const ProposalsInChallengeIndex = () => {
  let params = useParams();
  const challengeid: number = +params.challengeid!;

  const [formData, setFormData] = useState<ProposalFormType>({
    num_per_page: 12,
    page_number: 1,
    challenge_id: [challengeid],
    order_by: "proposal_name",
    ordering: "asc",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [formData.page_number, formData.num_per_page]);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const {
    loading: loading_proposal,
    error: error_proposal,
    proposalData,
  } = useAllProposalsData(formData);

  const challengeFormData = {
    challenge_id: challengeid,
  };
  const {
    loading: challenge_loadig,
    challengeData,
    error: challenge_error,
  } = useSingleChallengeData(challengeFormData);

  let xl = 4;
  let md = 6;

  const changeNumberPerPage = (event: SelectChangeEvent) => {
    let numberPerPage = parseInt(event.target.value);
    setFormData({
      ...formData,
      num_per_page: numberPerPage,
      page_number: 1,
    });
  };

  const sortPage = (sortData: {
    order_by: string;
    ordering: "desc" | "asc";
  }) => {
    setFormData((prevState) => ({
      ...prevState,
      order_by: sortData.order_by,
      ordering: sortData.ordering,
      page_number: 1,
    }));
  };

  const searchPage = (searchData: string) => {
    setFormData((prevState) => ({
      ...prevState,
      proposal_name: searchData,
      page_number: 1,
    }));
  };

  const formDataHandler = (data: any) => {
    setFormData((prevState) => ({
      ...prevState,
      rating: data.rating,
      is_challenge_proposal: data.is_challenge_proposal,
      amount_requested: data.amount_requested,
      funded_status: data.funded_status,
      page_number: 1,
    }));
  };

  const removeChallengeProposal = () => {
    if ("is_challenge_proposal" in formData) {
      let formData1: any = formData;
      delete formData1.is_challenge_proposal;
      setFormData(formData1);
    }
  };

  const [viewStyle, setViewStyle] = useState("grid");

  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    newViewStyle: string
  ) => {
    setViewStyle(viewStyle === "list" ? "grid" : "list");
  };

  let proposalRows: any = [];
  proposalData.items.map((proposal: any) =>
    proposalRows.push({
      ranking: proposal.ranking,
      name: {
        proposal_name: proposal.proposal_name,
        proposal_id: proposal.proposal_id,
      },
      fund_id: proposal.fund_id,
      challenge: {
        challenge_name: proposal.challenge_name,
        challenge_id: proposal.challenge_id,
      },
      proposer: {
        proposer_name: proposal.user_name,
        proposer_id: proposal.user_id,
      },
      status: proposal.funded_status ? "Yes" : "No",
      amount_requested: proposal.amount_requested,
      rating: proposal.rating.toFixed(1),
      votes: proposal.result_votes,
      id: proposal.proposal_id,
    })
  );

  return (
    <>
      <Navbar />
      <Header
        pageName={"Proposals in Challenge " + challengeData.challenge_name}
      >
        <>
          <Typography
            variant="h6"
            className={styles.typoLink}
            component={Link}
            to={"/fund/" + challengeData.fund_id + "/challenges"}
          >
            Fund Source:
            {" " + challengeData.fund_name}
          </Typography>
        </>
      </Header>

      {challenge_loadig && <ChallengeQuickStatsLoading />}

      {!challenge_loadig && challenge_error && (
        <LoadingError h1="No Proposal Data !" />
      )}

      {!challenge_loadig && challenge_error === null && (
        <ChallengeQuickStats
          challenge_stats={{
            ...challengeData.quick_stats_data,
            challenge_amount: challengeData.challenge_amount,
          }}
        />
      )}

      <SideFilterFrame
        headerName="Proposals"
        goToTop={goToTop}
        filter={
          <ProposalFilter
            formDataHandler={(data: any) => formDataHandler(data)}
            removeChallengeProposal={removeChallengeProposal}
            less={true}
          />
        }
        sort={
          <>
            <ToggleButtonGroup
              color="primary"
              value={viewStyle}
              exclusive
              onChange={handleViewChange}
              size="small"
            >
              <ToggleButton value="list">
                <FormatListBulletedSharp fontSize="small" />
              </ToggleButton>
              <ToggleButton value="grid">
                <GridView fontSize="small" />
              </ToggleButton>
            </ToggleButtonGroup>
            <ProposalSortMenu sortPage={sortPage} hideFund={true} />
          </>
        }
        search={
          <SearchInput
            searchPage={searchPage}
            placeholder="Search by Proposal"
          />
        }
      >
        <>
          {loading_proposal && viewStyle === "grid" && (
            <Grid container spacing={4} sx={{ justifyContent: "flex-start" }}>
              {cards.map((item) => (
                <Grid
                  xs={12}
                  md={md}
                  xl={xl}
                  item
                  key={item}
                  sx={{ display: "flex", alignSelf: "100%" }}
                >
                  <ProposalCardLoading />
                </Grid>
              ))}
            </Grid>
          )}

          {viewStyle === "list" && error_proposal === null && (
            <Box sx={{ width: "100%" }}>
              <DataGrid
                componentsProps={{
                  pagination: { classes: null },
                }}
                rows={proposalRows}
                columns={proposalColumns}
                pageSize={formData.num_per_page}
                rowsPerPageOptions={[9, 12, 24, 36, 72, 99]}
                // checkboxSelection
                disableSelectionOnClick
                autoHeight
                // experimentalFeatures={{ newEditingApi: true }}
                loading={loading_proposal}
                page={
                  formData.page_number - 1 >= 0 ? formData.page_number - 1 : 0
                }
                onPageSizeChange={(newVal) => {
                  setFormData({
                    ...formData,
                    num_per_page: newVal,
                    page_number: 1,
                  });
                }}
                onPageChange={(newVal) => {
                  setFormData({
                    ...formData,
                    page_number: newVal + 1,
                  });
                }}
                paginationMode="server"
                rowCount={proposalData.number_of_rows}
              />
            </Box>
          )}

          {!loading_proposal && error_proposal && (
            <LoadingError h1="No Data found for options provided." />
          )}
          {!loading_proposal &&
            error_proposal === null &&
            viewStyle === "grid" && (
              <>
                <Grid
                  container
                  spacing={4}
                  sx={{ justifyContent: "flex-start" }}
                >
                  {Array.isArray(proposalData.items) &&
                    proposalData.items.map((item, index) => (
                      <Grid
                        xs={12}
                        md={md}
                        xl={xl}
                        item
                        key={index}
                        sx={{ display: "flex", alignSelf: "100%" }}
                      >
                        <ProposalCard {...item} />
                      </Grid>
                    ))}
                </Grid>
                <div className="pullRight">
                  <Box className="paginationContainer">
                    <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                      <InputLabel id="demo-select-small">Per Page:</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        name="numberPerPage"
                        value={formData.num_per_page.toString()}
                        label="Per Page"
                        onChange={changeNumberPerPage}
                      >
                        <MenuItem value={"12"}>12</MenuItem>
                        <MenuItem value={"24"}>24</MenuItem>
                        <MenuItem value={"36"}>36</MenuItem>
                        <MenuItem value={"48"}>48</MenuItem>
                        <MenuItem value={"60"}>60</MenuItem>
                      </Select>
                    </FormControl>
                    <Pagination
                      count={Math.ceil(
                        proposalData.number_of_rows / formData.num_per_page
                      )}
                      onChange={(
                        event: React.ChangeEvent<unknown>,
                        value: number
                      ) => {
                        setFormData({
                          ...formData,
                          page_number: value,
                        });
                      }}
                      page={formData.page_number}
                    />
                  </Box>
                </div>
              </>
            )}
        </>
      </SideFilterFrame>
      <Footer />
    </>
  );
};

export default ProposalsInChallengeIndex;
